'use strict';

angular.module('dekky.forms.themes.far')
.run(function($templateCache) {
	$templateCache.put('/dekky.forms/themes/far/fields/fileUpload.html',
		'<div ng-init="model = field.uploader.queue">' +
			'<input class="btn-file-upload__input" id="{{ field.name }}" type="file" nv-file-select uploader="field.uploader">' +
		'</div>'
	);
});